
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lead/[lead_page]",
      function () {
        return require("private-next-pages/lead/[lead_page]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lead/[lead_page]"])
      });
    }
  